// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2JxXR","signatureButtonsRight":"ModalSign_signatureButtonsRight__jGFJQ"};